import { DOMRouteHandler } from './DOMRouteHandler';
import { drawBreedList } from '../modules/breedList';
import { drawDiseaseList } from '../modules/diseaseList';
import { drawTraitsList } from '../modules/traitsList';
import { initBreedSpecificDiseaseSelector } from '../modules/breedSpecificDiseaseSelector';
import initHealthList from '../modules/healthList';
import { initPDPTabs } from '../modules/PDPTabs';
import { maybeClickAddToCartButton } from '../modules/maybeClickAddToCartButton';
import { updateTheFeaturedImageBasedOnCampaign } from '../modules/pdpImageConsistency';
import { updateValueOfHiddenSelectBoxOnRadioChange } from '../utils/variantSelectChangeEvent';

export class TemplateProduct extends DOMRouteHandler {
  static async initAsync(): Promise<void> {
    await initBreedSpecificDiseaseSelector();
    await drawDiseaseList();
    await drawBreedList();
    await drawTraitsList();
    initHealthList();
    initPDPTabs();
    updateValueOfHiddenSelectBoxOnRadioChange();
    maybeClickAddToCartButton();

    if (window.current_variant_sku) {
      updateTheFeaturedImageBasedOnCampaign(window.current_variant_sku);
    }
  }
}
